exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-img {\n  width: 100px;\n  float: left;\n  padding: 12px 0px 0px 6px;\n  margin-right: 10px;\n  height: 180px;\n}\n\n.card {\n  min-height: 180px;\n  box-shadow: none;\n}\n\n.add-article {\n  border: 1px dashed #000;\n  background-color: rgba(0,0,0,0.1);\n  border-spacing: 3px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.add-article > span {\n  width: 100%;\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/overview/overview.component.css
// module id = 381
// module chunks = 1